import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { Geolocation } from '@capacitor/geolocation';
export function requestPermissions() {
  return _requestPermissions.apply(this, arguments);
}
function _requestPermissions() {
  _requestPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var force,
      permissions,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          force = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
          _context2.prev = 1;
          _context2.next = 4;
          return Geolocation.checkPermissions();
        case 4:
          permissions = _context2.sent;
          if (!(!permissions || permissions.location != 'granted' || force)) {
            _context2.next = 8;
            break;
          }
          _context2.next = 8;
          return Geolocation.requestPermissions();
        case 8:
          _context2.next = 12;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](1);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 10]]);
  }));
  return _requestPermissions.apply(this, arguments);
}
export function getLocation() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    enableHighAccuracy: false,
    timeout: 5000
  };
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
      var timeout, location;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return requestPermissions();
          case 3:
            if (params.timeout) {
              timeout = setTimeout(function () {
                reject('Timeout');
              }, params.timeout);
            }
            _context.next = 6;
            return Geolocation.getCurrentPosition(params);
          case 6:
            location = _context.sent;
            // console.log("Geolocation " + location.coords.latitude)
            resolve(location);
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            reject(_context.t0);
          case 13:
            clearTimeout(timeout);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}